import type { EventName } from "@lit/react";
import { TabSheet as TabSheetElement, type TabSheetEventMap as _TabSheetEventMap, } from "@vaadin/tabsheet/vaadin-tabsheet.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { TabSheetElement, };
export type TabSheetEventMap = Readonly<{
    onItemsChanged: EventName<_TabSheetEventMap["items-changed"]>;
    onSelectedChanged: EventName<_TabSheetEventMap["selected-changed"]>;
}>;
const events = { onItemsChanged: "items-changed", onSelectedChanged: "selected-changed" } as TabSheetEventMap;
export type TabSheetProps = WebComponentProps<TabSheetElement, TabSheetEventMap>;
export const TabSheet = createComponent({
    elementClass: TabSheetElement, events, react: React, tagName: "vaadin-tabsheet"
});
